import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../../../core/services/AuthServices/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginReq} from "../../../../core/models/LoginReq";
import {Subscription} from "rxjs";
import {TokenUserProfile} from "../../../../core/models/TokenUserProfile";
import {HttpErrorResponse} from "@angular/common/http";
import {AuthUtil} from "../../Utils/AuthUtil";
import { LocalStorageService } from 'src/app/shared/local-storage.service';
import {CustomSwal} from "../../../../Modules/Shared/Services/CustomSwal";
import { LoginHandlerService } from 'src/app/shared/login-handler.service';
import {ThisReceiver} from "@angular/compiler";
import {JwtHelperService} from '@auth0/angular-jwt';
import { Tokens } from 'src/app/core/models/Tokens';
import { SessionTimerService } from 'src/app/shared/session_service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

/**
 * Login component
 */
export class LoginComponent implements OnInit, OnDestroy {

  loginForm: UntypedFormGroup;
  submitted = false;
  error = '';
  returnUrl: string;
  private subscriptions: Subscription[] = [];
  loading: boolean;

  //  login attempt handler variables
  clickCount: number = 0
  isButtonDisabled: boolean = false
  lockTime: number | null = null
  remainingTime: number | null = null

  // set the current year
  year: number = new Date().getFullYear();

  // tslint:disable-next-line: max-line-length
  constructor(private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute, private router: Router,
              private authenticationService: AuthenticationService,
              public localStorage : LocalStorageService,
              public loginAttemptService : LoginHandlerService,
               public jwttokenService: JwtHelperService,
               public sessionTimerService: SessionTimerService

  ) {
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
/*      username: ['S0289.0105.2016', [Validators.required]],
      password: ['testing@1234', [Validators.required]],*/
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    if (this.authenticationService.isLoggedIn()) {
      this.navigateToRespectivePages()
    }

    const storedState = localStorage.getItem('loginButtonState');
    if (storedState) {
      const parsedState = JSON.parse(storedState);
      this.isButtonDisabled = parsedState.isButtonDisabled;
      this.clickCount = parsedState.clickCount;
      this.lockTime = parsedState.lockTime;
    }

    // If the button is locked and one hour has passed, unlock it
    if (this.isButtonDisabled && this.lockTime) {
      this.calculateRemainingTime();
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm?.controls;
  }

  /**
   * Form submit
   */
  onSubmit(value) {
    this.error = null;
    const loginRequest: LoginReq = new LoginReq();
    loginRequest.username = value.username;
    loginRequest.password = value.password;
    this.loading = true;

    this.subscriptions.push(this.authenticationService.sendLoginRequest(loginRequest).subscribe(
      {
        next: (response: any) => {
          this.loading = false;
          const tokenUserProfile: any = AuthUtil.insertAuthenticationTokenToSessionStorage(response);
          const userProfile:TokenUserProfile = AuthUtil.getUser()
          this.authenticationService.userProfile.next(userProfile);
          this.navigateToRespectivePages();
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          if (error.error.detail) {
            this.error = error.error.detail;
          } else {
            this.error = 'An Error Occurred Please Try Again Later';
          }
        }
      }
    ))

  }tokenUserProfile

  navigateToRespectivePages() {

    // if (this.authenticationService.userProfile.getValue().user?.user_category?.category === 'BENEFICIARY') {
    //   this.router.navigateByUrl('/beneficiary').then()
    // } else {
    //   this.authenticationService.logOut();
    //   this.error = 'Invalid Category Please Contact Us For Further Support';
    // }'

    const userProfile:TokenUserProfile = AuthUtil.getUser();
    console.log(userProfile);

    // const userProfile: TokenUserProfile = JSON.parse(localStorage.getItem('tokenUserProfile'))

   // let userData =  this.localStorage.getObjData('tokenUserProfile')


    // console.log(userData)getFromLocalStorage
    // const parsedData = JSON.parse(userData);

    if(userProfile != null)
    {
      /*if (userProfile?.user?.user_category?.category === 'BENEFICIARY') {
        this.router.navigateByUrl('/beneficiary').then()
      } else {
        // this.authenticationService.logOut();
        // this.error = 'Invalid Category Please Contact Us For Further Support';
      }*/
      let userCategory = userProfile?.user.user_category?.category;

      // console.log(userCategory)

      switch (userCategory) {
        case 'SSHIP_APPLICANT':
          this.router.navigateByUrl('/scholarship/home').then()
          this.localStorage.saveData('username', userProfile?.user.username)
          break;
        case  'BENEFICIARY':
          let loanee_id = userProfile.user.user_category.beneficiary.loanee_id;
          let is_refund_applicant = userProfile?.user?.user_category?.beneficiary?.non_benef_refund
          console.log(is_refund_applicant + 'refund-applicant-status');
          if (loanee_id > 0 || is_refund_applicant){
            this.router.navigateByUrl('/beneficiary').then();
          }else{
            //re route applicants to home page
            this.router.navigateByUrl('/application-v2/home/landing').then();
          }

          this.localStorage.saveData('username', userProfile?.user.username)
          break;

        case 'OFFICER':
          this.router.navigateByUrl('/hli').then();
          this.localStorage.saveData('username', userProfile?.user.username)
          break;
        default :
          this.authenticationService?.logOut();
          this.error = 'Invalid Category Please Contact Us For Further Support';
          CustomSwal.toastFailed('Invalid Category Please Contact Us For Further Support');
          break;
      }
    }
    else {
      this.authenticationService.logOut();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  onLoginSubmit(event: Event, value): void {
    event.preventDefault();

    // Increment click count and lock the button
    if (!this.isButtonDisabled) {
      // login attempt counts/
      this.clickCount++;
      if (this.clickCount >= 3) {
        this.isButtonDisabled = true;
        this.lockTime = new Date().getTime(); // Store the timestamp when the button is locked
        this.updateLocalStorage(); // Update local storage when the button is locked

        // Start counting the remaining time
        this.calculateRemainingTime();
        setTimeout(() => this.unlockButton(), this.loginAttemptService.THREE_MINUTES_IN_MILLISECONDS); // 1 hour timeout
      } else {
        this.onSubmit(value)
      }
    }
  }


  unlockButton(): void {
    this.clickCount = 0;
    this.isButtonDisabled = false;
    this.lockTime = null;
    localStorage.removeItem('loginButtonState'); // Remove the state from local storage when the button is unlocked
  }

  calculateRemainingTime(): void {
    if (this.isButtonDisabled && this.lockTime) {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - this.lockTime;
      const remainingTimeInMillis = this.loginAttemptService.THREE_MINUTES_IN_MILLISECONDS - elapsedTime;

      this.remainingTime = Math.ceil(remainingTimeInMillis / 1000); // Convert remaining time to seconds
      if (this.remainingTime < 0) {
        this.unlockButton()
        this.remainingTime = null; // Reset the remaining time if it becomes negative (time's up)
      } else {
        setTimeout(() => this.calculateRemainingTime(), 1000); // Update the remaining time every second
      }

    }
  }

  updateLocalStorage(): void {
    // Store the login button state in local storage
    const stateToStore = { isButtonDisabled: this.isButtonDisabled, clickCount: this.clickCount, lockTime: this.lockTime };
    localStorage.setItem('loginButtonState', JSON.stringify(stateToStore));
  }
  validateUsername(){
    let username = this.loginForm.get('username').value;
    let password = this.loginForm.get('password').value;
    if(username.includes('/')){
      username = username.replace('/','.')
      this.loginForm.setValue({
        username: username,
        password: password
      })
    }
    if(username.includes('\\')){
      username = username.replace('\\','.')
      this.loginForm.setValue({
        username: username,
        password: password
      })
    }
    if(username.includes(' ')){
      username = username.replace(' ','')
      this.loginForm.setValue({
        username: username,
        password: password
      })
    }
  }

  }
